import React, { useState, useEffect } from 'react';
import { Container, Col, Row, Modal, Button } from 'react-bootstrap';
import apiRequests from './api-helpers/ApiRequests';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';




const AddDictionaryItemCars = ({ show, onChangeAddItemFormVisibilityHandler, addNewEventNotificationCallback, userData }) => {
    const [NewItem, setNewItem] = useState({});
    const [errors, setErrors] = useState("");
    const [isValidForm, setIsValidForm] = useState(true);
    const [brandsList, setBrandsList] = useState([]);
    const { t } = useTranslation();


    const hideModal = () => {
        setNewItem({});
        setErrors("");
        setIsValidForm(true);
        onChangeAddItemFormVisibilityHandler(false);
    };

    const loadCarsList = () => {
        const params = {
            DataInHttpResponse: true,
            SearchParams: [],
            ReportID: "90",
        };

        apiRequests.getDataByUrlWithParam('webconapi/GetWebconReport', params, loadCarsListCallback);
    };

    const loadCarsListCallback = (data) => {
        if (data && data.rows && data.rows.length > 0) {
            const brands = data.rows.map(row => ({
                Name: row.cells[1].value,
            }));
            setBrandsList(brands);
        }
    };

    const onInputChange = (event) => {
        const { name, value } = event.target;

        setNewItem(prev => {
            const updatedItem = { ...prev, [name]: value };

            if (!isValidForm) {
                apiRequests.getDataByUrlWithParam('webconapi/AddNewCarValidate', updatedItem, newItemCallback);
            }

            return updatedItem;
        });
    };

    const onFormSubmit = (event) => {
        event.preventDefault();

        const newItem = {
            ...NewItem,
            CompanyWorkflowId: userData.CompanyWorkflowId + "",
            AccountWorkflowId: userData.AccountWorkflowId + "",
        };

        apiRequests.getDataByUrlWithParam('webconapi/AddNewCar', newItem, newItemCallback);
    };

    const newItemCallback = (data, response) => {
        if (response.status === 400) {
            if (data.errors) {
                setIsValidForm(false);
                setErrors(data.errors);
            }
        } else if (response.status === 200) {
            if (data.Message === "ok") {
                hideModal();
            } else {
                setErrors("");
            }
        }

        addNewEventNotificationCallback();
    };

    useEffect(() => {
        loadCarsList();
    }, []);

    return (
        <Modal show={show} onHide={hideModal}>
            <Modal.Header closeButton>
                <Modal.Title>{ t('cars.modal.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form id="new-ev-not-form" className="form-font" onSubmit={onFormSubmit}>
                    <div className="mb-3">
                        <label htmlFor="mark" className="form-label m-0 p-0">
                            <sup className="text-danger">*</sup>{t('cars.modal.brandLabel')}
                        </label>
                        <select className="form-control" id="mark" name="Mark" onChange={onInputChange} required>
                            <option value="">{t('cars.modal.brandPlaceholder')}</option>
                            {brandsList.map((brand, index) => (
                                <option key={index} value={brand.Name}>{brand.Name}</option>
                            ))}
                        </select>
                        <span className="text-danger">
                            {errors.Mark ? errors.Mark[0] : ""}
                        </span>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="registationNumber" className="form-label m-0 p-0">
                            <sup className="text-danger">*</sup>{t('cars.modal.registrationLabel')}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="registationNumber"
                            name="RegistationNumber"
                            onChange={onInputChange}
                        />
                        <span className="text-danger">
                            {errors.RegistationNumber ? errors.RegistationNumber[0] : ""}
                        </span>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button form="new-ev-not-form" type="submit" className="btn btn-primary">
                    {t('common.add')}
                </button>
                <Button variant="secondary" onClick={hideModal}>
                    {t('common.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddDictionaryItemCars;
